import Editor from '@monaco-editor/react'
import { useTheme } from 'next-themes'

interface MarkdownMonacoEditorProps {
  value: string
  onChange: (value: string) => void
  dataTestId?: string
  readOnly?: boolean
  ariaLabel?: string
  plain?: boolean
}

export function MarkdownMonacoEditor({ value, onChange, dataTestId, readOnly = false, ariaLabel, plain = false }: MarkdownMonacoEditorProps) {
  const { resolvedTheme } = useTheme()

  return (
    <div className="h-full" data-testid={dataTestId}>
      <Editor
        height="100%"
        language="markdown"
        theme={resolvedTheme === 'dark' ? 'vs-dark' : 'vs'}
        value={value}
        onChange={(val) => onChange(val ?? '')}
        options={{
          ariaLabel,
          readOnly,
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: plain ? 'off' : 'on',
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          tabSize: 2,
          renderLineHighlight: plain ? 'none' : 'line',
          folding: !plain,
          ...(plain ? { lineDecorationsWidth: 16, padding: { top: 16 }, overviewRulerLanes: 0, hideCursorInOverviewRuler: true } : {}),
        }}
      />
    </div>
  )
}
